import { datadump } from "../../../actions/consumerAction";

const CoinTable = () => {
  return (
    <div className="col-lg-12 col-md-11">
      <div className="all-cate-tags">
        <div className="row justify- content-between">
          <div className="col-lg-12 col-md-12">
            <div className="card card-static-2 mb-30">
              <div className="card-body-table">
                <div className="table-responsive">
                  <table className="table ucp-table table-hover">
                    <thead>
                      <tr>
                        <th>OrderId</th>
                        <th>Date</th>
                        <th>Coin Balance</th>
                        <th>Coins Used</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datadump.map((order, index) => {
                        return (
                          <tr key={index}>
                            <td>{order.orderId}</td>
                            <td>{order.orderDateTime}</td>
                            <td>{order.coinBalance}</td>
                            <td>{order.coinsUsed}</td>
                          </tr>
                        );
                      })}
                      <tr className="bold-table-text">
                        <th>Grand Total</th>
                        <th></th>
                        <th>0</th>
                        <th>0</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoinTable;
